import React, { useCallback, useEffect, useState } from 'react';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { AnimatedSection } from './AnimatedSection';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Dominique',
    role: 'VP Sales, Clearstep Health',
    content: 'We were spending on conferences with no way to defend the number. Turnout gave us a forecast before we booked anything, then hit it. Last quarter events came in at 5.2x, which is better than anything our outbound team is producing right now.',
    image: 'https://cdn.magicpatterns.com/uploads/9WWS2deHaJvdr1GaZfEQ1x/0010_Brio_Photography.png',
    logo: 'https://cdn.magicpatterns.com/uploads/s8Y6nzsiuRyEvP2FHhV2kh/33c952_4fddab6300d04fb0954d3cb229081395~mv2.png',
    link: 'https://www.phoxevents.com/about',
    stars: 5
  }, {
    name: 'Busola',
    role: 'CRO, Northwind Data',
    content: 'I do not have a field marketer and I am not hiring one. Turnout is that function, and I get one bill instead of thirty receipts. My cost per meeting from events is now lower than my cost per meeting from outbound.',
    image: 'https://cdn.magicpatterns.com/uploads/9RHmZAnzM5Y1qc8grqc9FK/download.jpg',
    imageStyle: {
      objectFit: 'cover',
      objectPosition: '50% 18%',
      transform: 'scale(1.6)',
      transformOrigin: '50% 18%'
    },
    logo: 'https://cdn.magicpatterns.com/uploads/fJSy8iCi2m32tkwWiRKNNp/cropped-BUFLUS_logo-removebg-preview_(1).png',
    link: 'https://buflusevents.com/',
    stars: 5
  }, {
    name: 'Founder',
    role: 'Head of Sales, Meridian Ops',
    content: 'Thirty minutes a week. That is the whole commitment. We look at spend, forecast, and what actually got booked, and I make two decisions. Events finally sit in my pipeline model next to every other channel.',
    image: 'https://cdn.magicpatterns.com/uploads/4EWdPChyEYXuKDWKCzpKBL/logo.png',
    imageClass: 'object-contain bg-gray-900 p-3',
    link: 'https://ondotexperience.com/',
    stars: 5
  }];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const nextSlide = useCallback(() => {
    setCurrentIndex(prevIndex => prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1);
  }, [testimonials.length]);
  const prevSlide = useCallback(() => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1);
  }, [testimonials.length]);
  const goToSlide = index => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 5000);
  };
  useEffect(() => {
    let interval;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        nextSlide();
      }, 5000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isAutoPlaying, nextSlide]);
  const handleControlClick = callback => {
    setIsAutoPlaying(false);
    callback();
    setTimeout(() => setIsAutoPlaying(true), 5000);
  };
  return <section id="testimonials" className="py-20 bg-white" data-id="element-320" data-mp="1g6c403w09d3p">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-321" data-mp="1b5ofbov918cn">
        <AnimatedSection data-id="element-322" data-mp="1b8amhne89luc">
          <div className="text-center mb-16" data-id="element-323" data-mp="167wda20w45uq">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-324" data-mp="1674s7l4x5qip">
              What Sales Leaders Say
            </h2>
            <p className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto" data-id="element-325" data-mp="whl8kd9dtsms">
              Revenue teams running events as a forecastable channel.
            </p>
          </div>
        </AnimatedSection>
        <AnimatedSection delay={0.2} data-id="element-326" data-mp="ngvhfmv2gqfe">
          <div className="relative max-w-5xl mx-auto" data-id="element-327" data-mp="nhy41ilcw6pi">
            <div className="overflow-hidden" data-id="element-328" data-mp="ihsjsnhf1mhg">
              <div className="flex transition-transform duration-500 ease-in-out" style={{
              transform: `translateX(-${currentIndex * 100}%)`
            }} data-id="element-329" data-mp="igh5htqcgwc3">
                {testimonials.map((testimonial, index) => <div key={index} className="w-full flex-shrink-0 px-4" data-id="element-330" data-mp="2ij0719dz3e2u" data-mpi={index}>
                    <div className="bg-gray-50 rounded-2xl p-10 md:p-12 flex flex-col md:flex-row items-center md:items-start gap-8 border border-gray-100" data-id="element-331" data-mp="23vf2rc5d38tc">
                      <div className="flex-shrink-0 flex flex-col items-center gap-3" data-id="element-332" data-mp="28sfea2kzd3ru">
                        <div className="h-24 w-24 rounded-full overflow-hidden border-4 border-white shadow-md" data-id="element-333" data-mp="1usw659s65sfj">
                          {testimonial.image ? <img src={testimonial.image} alt={testimonial.name} className={`h-full w-full ${testimonial.imageClass || 'object-cover'}`} style={testimonial.imageStyle || {}} data-id="element-334" data-mp="1kx2urtq6s4zc" /> : <div className={`h-full w-full ${testimonial.initialsColor || 'bg-indigo-600'} flex items-center justify-center`} data-id="element-335" data-mp="18m1svkeyrqhi">
                              <span className="text-white text-3xl font-bold" data-id="element-336" data-mp="1ibv42kb723l8">
                                {testimonial.initials}
                              </span>
                            </div>}
                        </div>
                        {testimonial.logo && <a href={testimonial.link} target="_blank" rel="noopener noreferrer" className="block" data-id="element-337" data-mp="1nb7z3sc7ygyw">
                            <img src={testimonial.logo} alt="Company logo" className="h-8 object-contain opacity-80 hover:opacity-100 transition-opacity" data-id="element-338" data-mp="1wcfmhfd75xe7" />
                          </a>}
                      </div>
                      <div className="flex-grow text-center md:text-left" data-id="element-339" data-mp="26yfu7pg69n7l">
                        <Quote className="h-8 w-8 text-indigo-200 mb-4 mx-auto md:mx-0" data-id="element-340" data-mp="2b0j6ggao0vtx" />
                        <p className="text-gray-800 text-xl md:text-2xl font-medium italic mb-6 leading-relaxed" data-id="element-341" data-mp="2b2vvfdeuc6gh">
                          "{testimonial.content}"
                        </p>
                        <div data-id="element-342" data-mp="2kwmeu3w41qpb">
                          {testimonial.link ? <a href={testimonial.link} target="_blank" rel="noopener noreferrer" className="group" data-id="element-343" data-mp="2pvz3mu6jl7uj">
                              <h3 className="text-lg font-bold text-gray-900 group-hover:text-indigo-600 transition-colors" data-id="element-344" data-mp="33pzwj7atc0mz">
                                {testimonial.name}
                              </h3>
                              <p className="text-indigo-600 font-medium group-hover:underline" data-id="element-345" data-mp="3it19hr88zlb0">
                                {testimonial.role}
                              </p>
                            </a> : <>
                              <h3 className="text-lg font-bold text-gray-900" data-id="element-346" data-mp="34syy8nug3q4q">
                                {testimonial.name}
                              </h3>
                              <p className="text-indigo-600 font-medium" data-id="element-347" data-mp="5f68qo4r84gw">
                                {testimonial.role}
                              </p>
                            </>}
                        </div>
                        <div className="flex justify-center md:justify-start mt-4" data-id="element-348" data-mp="3nq9tlxcyhzew">
                          {[...Array(testimonial.stars)].map((_, i) => <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" data-id="element-349" data-mp="jd4nhumzm2wx" data-mpi={i} />)}
                        </div>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>

            <button onClick={() => handleControlClick(prevSlide)} className="absolute left-0 top-1/2 -translate-y-1/2 -ml-4 md:-ml-12 bg-white rounded-full p-3 shadow-lg text-gray-600 hover:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 z-10 transition-colors" aria-label="Previous testimonial" data-id="element-350" data-mp="t4sfvyt98m87">
              <ChevronLeft size={24} data-id="element-351" data-mp="1bsfbbb9z62iq" />
            </button>
            <button onClick={() => handleControlClick(nextSlide)} className="absolute right-0 top-1/2 -translate-y-1/2 -mr-4 md:-mr-12 bg-white rounded-full p-3 shadow-lg text-gray-600 hover:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 z-10 transition-colors" aria-label="Next testimonial" data-id="element-352" data-mp="1gsjqmxz5cr7d">
              <ChevronRight size={24} data-id="element-353" data-mp="2jjb8n6fvsha3" />
            </button>

            <div className="flex justify-center space-x-3 mt-8" data-id="element-354" data-mp="2ekzvomuahqnn">
              {testimonials.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`w-3 h-3 rounded-full focus:outline-none transition-colors ${index === currentIndex ? 'bg-indigo-600' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Go to testimonial ${index + 1}`} data-id="element-355" data-mp="2skizx4jzchuo" data-mpi={index} />)}
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}